/* The number on a sub-category tile, counted as what is in stock.

   Liquid cannot reach it: another collection's products stop at fifty, and
   the filter counts on the page belong to the category you are standing in
   rather than the one the tile leads to. So the tile goes out with no number
   and one small request per tile asks the count template for the real one.

   The answers are the same for every visitor, so the CDN serves most of them,
   and they are kept for the rest of the visit as well. A tile that cannot be
   counted simply stays without a number, which is better than one that is
   not true. */
(function () {
  var TILES = '[data-subcollection-count]';
  var STORE = 'bakkeleg:instock-counts';
  var KEEP = 15 * 60 * 1000;

  function cache() {
    try {
      return JSON.parse(window.sessionStorage.getItem(STORE)) || {};
    } catch (error) {
      return {};
    }
  }

  function remember(all) {
    try {
      window.sessionStorage.setItem(STORE, JSON.stringify(all));
    } catch (error) {
      /* a private window, or the box is full. The counting still works, it
         just happens again next time. */
    }
  }

  function show(tile, count) {
    var slot = tile.querySelector('.subcollection-tile__count');
    if (!slot) return;

    /* Nothing in stock in there, so the tile says its name and no more, and
       a tile that could not be counted stays as it is rather than showing a
       number that is not true. */
    if (!(count > 0)) return;

    slot.textContent = count;
    slot.classList.remove('subcollection-tile__count--counting');
  }

  function countUrl(tile) {
    var href = tile.getAttribute('href');
    if (!href) return null;

    var path = href.split('?')[0].split('#')[0];
    return path + '?filter.v.availability=1&view=count';
  }

  function run() {
    var tiles = document.querySelectorAll(TILES);
    if (!tiles.length) return;

    var known = cache();
    var now = Date.now();
    var fresh = {};
    var pending = [];

    for (var i = 0; i < tiles.length; i++) {
      var tile = tiles[i];
      var url = countUrl(tile);
      if (!url) continue;

      var held = known[url];
      if (held && now - held.at < KEEP) {
        fresh[url] = held;
        show(tile, held.count);
        continue;
      }

      pending.push({tile: tile, url: url});
    }

    if (!pending.length) {
      remember(fresh);
      return;
    }

    var left = pending.length;

    pending.forEach(function (job) {
      window
        .fetch(job.url, {headers: {Accept: 'text/html'}, credentials: 'same-origin'})
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (text) {
          var count = parseInt(String(text).trim(), 10);
          if (isNaN(count)) return;

          fresh[job.url] = {count: count, at: now};
          show(job.tile, count);
        })
        .catch(function () {
          /* the tile keeps the total it was rendered with */
        })
        .then(function () {
          left -= 1;
          if (left === 0) remember(fresh);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
